<template>
    <Heading :title="$t('sections.latestActions')" />
    <div v-if="getLimitedAuctions.length > 0" class="product-carousel-container mt-5">
      <button class="carousel-btn prev-btn" @click="prevSlide" :disabled="currentSlide === 0">&#9664;</button>
      <div class="product-carousel-wrapper">
        <div class="product-carousel-track" :style="carouselTrackStyle">
          <div
            v-for="auction in getLimitedAuctions"
            :key="auction._id"
            class="product-slide"
          >
            <ProductCard v-bind="auction" :endDate="new Date(auction.endDate)" :verticalIcons="'true'" />
          </div>
        </div>
      </div>
      <button class="carousel-btn next-btn" @click="nextSlide" :disabled="currentSlide >= maxSlides">&#9654;</button>
    </div>
    <div v-else class="text-center p-5">
        <p>No latest products to display at the moment.</p>
    </div>
</template>

<script>
import { getAllProductsAndVariants } from "../../../composables/manageProducts";
import Heading from "../../atoms/SectionHeading/Heading.vue";
import ProductCard from "../../molecules/Product/ProductCard.vue";
export default {
  components: { Heading, ProductCard },
  data() {
    return {
      itemsPerPage: 9, 
      currentPage: 1,
      auctions: [],
      currentSlide: 0, 
      itemsVisible: 3, 
    };
  },
  created(){
    this.getProducts(this.itemsPerPage, this.currentPage);
  },
  props: {
    maxAuctions: {
      type: Number,
      default: 9
    },
  },
  computed: {
    getLimitedAuctions() {
      return this.auctions.slice(0, this.maxAuctions);
    },
    carouselTrackStyle() {
      const translateValue = this.currentSlide * 100;
      return {
        transform: `translateX(-${translateValue}%)`,
      };
    },
    maxSlides() {
      return Math.ceil(this.getLimitedAuctions.length / this.itemsVisible) - 1;
    }
  },
  methods: {
    async getProducts(itemsPerPage, currentPage) {
      try {
        let res = await getAllProductsAndVariants({
          limit: itemsPerPage,
          page: currentPage,
        });
        this.auctions = res.varianti || [];
      } catch (error) {
        console.error("Failed to fetch latest products:", error);
        this.auctions = [];
      }
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--;
      }
    },
    nextSlide() {
      if (this.currentSlide < this.maxSlides) {
        this.currentSlide++;
      }
    }
  }
};
</script>

<style scoped>
  /* Main container (for arrows) */
  .product-carousel-container {
    position: relative;
    width: 100%;
    padding: 0 50px;
    box-sizing: border-box;
  }
  /* Clipping mask */
  .product-carousel-wrapper {
    overflow: hidden;
    width: 100%;
  }
  /* Track - WITH GAPS between slides */
  .product-carousel-track {
    display: flex;
    transition: transform 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
    gap: 15px; /* Add gap between cards */
  }
  /* Individual slide container */
  .product-slide {
    box-sizing: border-box;
    flex: 0 0 calc(33.333% - 10px); /* Account for gap */
    padding: 0;
  }

  /* Arrow Button Styles */
  .carousel-btn {
    position: absolute;
    top: 40%;
    transform: translateY(-50%);
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    width: 35px;
    height: 35px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    z-index: 10;
    color: #333;
    transition: background-color 0.2s;
    border-radius: 4px;
  }
  .carousel-btn:hover:not(:disabled) {
    background-color: #e9ecef;
  }
  .carousel-btn:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .prev-btn { 
    left: 0; 
  }
  .next-btn { 
    right: 0; 
  }
  /* Responsive Adjustments */
  @media (max-width: 992px) {
    .product-slide { 
      flex: 0 0 50%; 
    }
  }
  @media (max-width: 767px) {
    .product-slide { 
      flex: 0 0 100%; 
    }
    .product-carousel-container {
      padding: 0 40px;
    }
  }
  /* Counter positioning fix */
  :deep(.prod-card-counter) { 
    margin-top: -15px; 
    /* border-radius: 0px !important; /!* Rimossa *!/ */
  }
  @media (max-width: 767.98px) { 
    :deep(.prod-card-counter) { 
      margin-top: 0px; 
    } 
  }
  @media (min-width: 768px) and (max-width: 1024px) { 
    :deep(.prod-card-counter) { 
      margin-top: 0px !important; 
    } 
  }
</style>